/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-08-22T13:39:18+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-09-21T16:05:32+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import autoPrefix from './../utilities/autoPrefix';
import transitions from './transitions';

class ScaleInChild extends Component {
  componentDidMount() {
    const {
      minScale,
      maxScale,
    } = this.props;

    // prepare for inital pop
    const style = this._containerNode.style;

    const savedTransition = style['transition'];

    style['transition'] = 'none';

    // init invisible
    style.opacity = '0';
    autoPrefix.set(style, 'transform', `scale(${minScale / 100})`);


    // do animate instantly after mount
    // it is a little slower than original animation (+5ms)
    setTimeout(function() {
      style.transition = savedTransition;
      style.opacity = '1';
      autoPrefix.set(style, 'transform', `scale(${maxScale / 100})`);
    }, 5);
  }


  componentDidUpdate(prevProps) {
    const style = this._containerNode.style;
    const {
      in: prevEnabled,
    } = prevProps;

    const {
      in: currentEnabled,
      maxScale,
      minScale,
    } = this.props;

    // will pop
    if (currentEnabled === true && prevEnabled !== currentEnabled) {
      style.opacity = '1';
      autoPrefix.set(style, 'transform', `scale(${maxScale / 100})`);
    }

    // will leave
    if (currentEnabled === false && prevEnabled !== currentEnabled) {
      style.opacity = '0';
      autoPrefix.set(style, 'transform', `scale(${minScale / 100})`);
    }
  }

  render() {
    const {
      children,
      maxScale, // eslint-disable-line no-unused-vars
      minScale, // eslint-disable-line no-unused-vars
      style,
      onExited,
      in: currentEnabled,
      ...other
    } = this.props;

    const mergedRootStyles = Object.assign({}, {
      position: 'absolute',
      height: '100%',
      width: '100%',
      top: 0,
      left: 0,
      transition: transitions.easeOut(null, ['transform', 'opacity']),
    }, style);

    return (
      <div {...other} ref={this.refContainer} style={mergedRootStyles}>
        {children}
      </div>
    );
  }

    refContainer = (node) => {
      this._containerNode = node;
    }
}

ScaleInChild.propTypes = {
  children: PropTypes.node,
  enterDelay: PropTypes.number,
  maxScale: PropTypes.number,
  minScale: PropTypes.number,
  style: PropTypes.object,
};

export default ScaleInChild;

